module.exports = __webpack_public_path__ + "img/022-slippers.4921ff83.svg";